module.exports = __webpack_public_path__ + "static/media/20.021.55fdd500.webp";